import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-route-trace-adjust',
  templateUrl: './route-trace-adjust.component.html',
  styleUrls: ['./route-trace-adjust.component.scss']
})
export class RouteTraceAdjustComponent implements OnInit {
  is_data_available = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  route_and_business_details: any;
  selected_route_details: any;
  is_route_closed = {
    'main_route': { 'route_id': 0, 'is_closed': false },
    'temp_route': { 'route_id': 0, 'is_closed': false }
  };

  constructor(
    public dialogRef: MatDialogRef<RouteTraceAdjustComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.selected_route_details = data;
    this.http.serveBusinessListForRouteRearrange(data).subscribe((business_data) => {
      this.is_data_available = true;
      this.route_and_business_details = business_data;
      this.is_route_closed['main_route']['route_id'] = this.route_and_business_details['main_route_details']['route_id'];
      this.is_route_closed['temp_route']['route_id'] = this.route_and_business_details['temp_route_details']['route_id'];
      console.log(business_data);
    }, (error) => {
      this.is_data_available = false;
      console.error(error);
    });
  }

  moveBusinessToTempRoute(business_id, business_index) {
    let data_dict = {
      'main_route_id': this.route_and_business_details['main_route_details']['route_id'],
      'temp_route_id': this.route_and_business_details['temp_route_details']['route_id'],
      'selected_business_id': business_id,
      'session_id': this.selected_route_details['session_id'],
      'date': this.selected_route_details['date']
    };
    this.http.moveBusinessToTempRoute(data_dict).subscribe((business_data) => {
      console.log(business_data);
      this.route_and_business_details['main_route_details']['tray_count'] = business_data['main_route_tray_count']['tray_count'];
      this.route_and_business_details['temp_route_details']['tray_count'] = business_data['temp_route_tray_count']['tray_count'];
      this.route_and_business_details['temp_route_details']['business_details'].push(this.route_and_business_details['main_route_details']['business_details'][business_index])
      this.route_and_business_details['main_route_details']['business_details'].splice(business_index, 1);
    }, (error) => {
      console.error(error);
    });

  }

  moveBusinessToMainRoute(business_id, business_index) {
    let data_dict = {
      'main_route_id': this.route_and_business_details['main_route_details']['route_id'],
      'temp_route_id': this.route_and_business_details['temp_route_details']['route_id'],
      'selected_business_id': business_id,
      'session_id': this.selected_route_details['session_id'],
      'date': this.selected_route_details['date']
    };
    this.http.moveBusinessToMainRoute(data_dict).subscribe((business_data) => {
      this.route_and_business_details['main_route_details']['tray_count'] = business_data['main_route_tray_count']['tray_count'];
      this.route_and_business_details['temp_route_details']['tray_count'] = business_data['temp_route_tray_count']['tray_count'];
      this.route_and_business_details['main_route_details']['business_details'] = [this.route_and_business_details['temp_route_details']['business_details'][business_index]].concat(this.route_and_business_details['main_route_details']['business_details']);
      this.route_and_business_details['temp_route_details']['business_details'].splice(business_index, 1);
      console.log(business_data);
    }, (error) => {
      console.error(error);
    });

  }


  closeRouteClicked(route_id, which_route) {
    const data = {
      'session_id': this.selected_route_details['session_id'],
      'date': this.selected_route_details['date'],
      'route_id': route_id,
      'which_route': which_route
    };
    console.log(data);
    this.http.prepareRouteIndentForTempRoute(data).subscribe((res_data) => {
      console.log(res_data);
      if (this.route_and_business_details['temp_route_details']['business_details'].length !== 0) {
        this.is_route_closed['temp_route']['is_closed'] = true;
      }
      this.is_route_closed['main_route']['is_closed'] = true;
      this.global.showSnakeBar('Indent Closed successfully! Close the Popup to download the indent');
      this.closeClicked();
    }, (error) => {
      console.log(error);
      alert(error['error']['error_message']);
    });
  }


  closeClicked() {
    console.log(this.is_route_closed);
    let temp_business_length = this.route_and_business_details['temp_route_details']['business_details'].length;
    if (temp_business_length !== 0 && !this.is_route_closed['main_route']['is_closed']) {
      if (confirm('You are moved ' + temp_business_length + ' booth to temp route and you are not closed the main route Do you want to exit?')) {
        let data_dict = {
          'temp_route_id': this.route_and_business_details['temp_route_details']['route_id'],
          'session_id': this.selected_route_details['session_id'],
          'date': this.selected_route_details['date']
        };
        this.http.rearrangeToOriginalRoute(data_dict).subscribe((data) => {
          this.is_route_closed['main_route']['is_closed'] = false;
          this.is_route_closed['temp_route']['is_closed'] = false;
          this.dialogRef.close({ 'data': this.is_route_closed });
        }, (error) => {
          console.log(error);
        });
      }
    } else {
      this.dialogRef.close({ 'data': this.is_route_closed });
    }
  }

  ngOnInit() {
  }

}
